import {
  CaseReducerActions,
  createSlice,
  Reducer,
  Slice,
} from '@reduxjs/toolkit';

import { loadingErrorMatcher } from '../matchers/loading-error.matcher';
import { loadingFulfilledMatcher } from '../matchers/loading-fulfiled.matcher';
import { loadingPendingMatcher } from '../matchers/loading-pending.matcher';
import { RootReducersModel } from '../models/root-reducers.model';
import { RootStateModel } from '../models/root-state.model';
import actionTypeErrorGuard from '../type-guards/action-type-error.guard';
import actionTypeFulfilledGuard from '../type-guards/action-type-fulfilled.guard';
import actionTypePendingGuard from '../type-guards/action-type-pending.guard';

const rootStateModel: RootStateModel = {
  isLoading: false,
  isApkUploadLoading: false,
  areAppIconsLoading: false,
};

export const rootSlice: Slice<RootStateModel, RootReducersModel> = createSlice({
  name: 'root',
  initialState: rootStateModel,
  reducers: {
    toggleApkFileUploadVisibility(state: RootStateModel) {
      state.isApkUploadLoading = !state.isApkUploadLoading;
    },
    setAreAppIconsLoading(state: RootStateModel, action) {
      state.areAppIconsLoading = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(actionTypePendingGuard, loadingPendingMatcher);
    builder.addMatcher(actionTypeFulfilledGuard, loadingFulfilledMatcher);
    builder.addMatcher(actionTypeErrorGuard, loadingErrorMatcher);
  },
});

export const rootActions: CaseReducerActions<RootReducersModel> =
  rootSlice.actions;

const rootSliceReducers: Reducer<RootStateModel> = rootSlice.reducer;

export default rootSliceReducers;
